import { Settings, PaintBucket, DollarSign, UserCheck } from "lucide-react";

const advantages = [
  {
    icon: Settings,
    title: "Turnkey Optionality",
    description: "In addition to helping clients source materials, we offer a turnkey solution with installation. Our crews are experienced, turning 3+ units per day with precision and quality."
  },
  {
    icon: PaintBucket,
    title: "Customization at Scale",
    description: "We provide custom-manufactured materials, working with your design team to match your vision. We serve large operator owners, allowing for economies of scale and consistency across properties."
  },
  {
    icon: DollarSign,
    title: "Price & Efficiency",
    description: "Due to our vertical integration and overseas procurement team, we create meaningful savings for our partners. Our streamlined process delivers projects faster and under budget."
  },
  {
    icon: UserCheck,
    title: "Single Point of Contact",
    description: "Our direct model simplifies project management by removing the need for a General Contractor. You get one clear line of communication from start to finish."
  }
];

const stats = [
  { value: "27%", label: "Cheaper Than Market" },
  { value: "3+", label: "Units Per Day" },
  { value: "$285K", label: "Vacancy Loss Prevented" },
  { value: "85%+", label: "ROC Performance" }
];

const AdvantagesSection = () => {
  return (
    <section 
      id="advantages" 
      className="section-padding bg-slate-900"
      data-testid="advantages-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-cyan-400 font-semibold text-sm tracking-widest uppercase mb-4 block">
            Why Choose Us
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
            Why Partners Choose{" "}
            <span className="text-cyan-400">Altura</span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Our unique approach delivers measurable results that help you maximize 
            the return on your multifamily investments.
          </p>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-16 p-8 bg-slate-800/50 rounded-lg border border-slate-700">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="text-center"
              data-testid={`stat-${index}`}
            >
              <div className="text-3xl sm:text-4xl font-bold text-cyan-400 mb-2 stat-number">
                {stat.value}
              </div>
              <div className="text-sm text-slate-400 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className="advantage-card bg-slate-800/50 rounded-lg p-8"
              data-testid={`advantage-${index}`}
            >
              <div className="w-14 h-14 bg-cyan-600/20 rounded-md flex items-center justify-center mb-6">
                <advantage.icon className="w-7 h-7 text-cyan-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4">
                {advantage.title}
              </h3>
              <p className="text-slate-400 leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
